<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.itens"
            :tbody-tr-class="rowClass"
            class="table-materiais"
            hide-filters
            hide-pagination
            ref="Table"
        >
            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click.stop="$refs.ModalDetalhes.open(item)"
                    color="outline-primary"
                    small
                    title="Exibir detalhes"
                >
                    <rkm-icon icon="align-justify" />
                </rkm-button>

                <template v-if="item.id && data.model.finalizada">
                    <rkm-button
                        v-if="!item.estornado || item.estornoSalvo"
                        :disabled="item.estornado"
                        :title="item.estornado ? 'Estornado' : 'Estornar'"
                        @click="handleEstorno(item)"
                        color="danger"
                        small
                    >
                        <rkm-icon icon="undo-alt" />
                    </rkm-button>

                    <rkm-button
                        v-else
                        title="Cancelar estorno"
                        @click="handleCancelEstorno(item)"
                        color="danger"
                        small
                    >
                        <rkm-icon icon="times" />
                    </rkm-button>
                </template>

                <template v-else>
                    <rkm-button
                        @click.stop="edit(index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="remove(index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </template>

            <template #afterTable>
                <div class="my-2">
                    <rkm-row>
                        <rkm-col>
                            <p>A linha em <span class="red">vermelho</span> representa uma entrada que foi estornada.</p>
                        </rkm-col>

                        <rkm-col class="text-right">
                            <h6 class="font-weight-bold">Quantidade de materiais inclusa: {{ data.model.itens.length }}</h6>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <h6 class="font-weight-bold">Valor total: R$ {{ valorTotal }}</h6>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-table>

        <ModalDetalhes ref="ModalDetalhes" />
    </div>
</template>

<script>
// Components.
import ModalDetalhes from './components/detalhe/Modal'

// Mixins.
import { formats, object } from '@/mixins'

export default {
    components: { ModalDetalhes },
    computed: {
        fields() {

            return [
                {
                    key: 'material.descricaoCompleta',
                    label: 'Material',
                    sortable: true,
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'lote',
                    label: 'Lote',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'validadeLote',
                    label: 'Validade do lote',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor unitário',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor total',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'fabricante.nome',
                    label: 'Fabricante',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
        valorTotal() {

            let valorTotal = 0.0

            this.data.model.itens.map(i => valorTotal += this.formatSumMoney(i.valorTotal))

            return this.formatMoney(valorTotal, 6)
        }
    },
    methods: {
        handleEstorno(item) {

            this.showDeleteConfirmation(
                'Deseja realmente estornar a entrada?',
                async () => item.estornado = true
            )
        },
        handleCancelEstorno(item) {

            this.showDeleteConfirmation(
                'Deseja realmente cancelar o estorno?',
                async () => item.estornado = false
            )
        },
        edit(index, item) {

            this.$emit('click-to-edit', { index, item: this.clone(item) })
        },
        remove(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o material?',
                async () => this.data.model.itens.splice(index, 1)
            )
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.estornado) {

                return 'table-danger'
            }
        }
    },
    mixins: [ formats, object ],
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
.table-materiais >>> .red { color: red; }
</style>